/* ============================================================================
 * cz-facets-drawer.js — Cozzari custom drawer filters interactions.
 *
 * Single source of truth per il comportamento del drawer filtri custom:
 *   1. Header height sync + toolbar sticky tracking (con .cz-stuck toggle)
 *   2. Filter values "Show more" toggle (3 righe collassate + button)
 *   3. Accordion animation altezza reale (max-height esatta in JS)
 *   4. Altezza drawer: decisa dal CSS con 100dvh, non piu' misurata qui
 *   5. Drawer close animation patch (1300ms apertura / 650ms chiusura)
 *   6. Custom sort dropdown Tiffany-style (sostituisce <select> nativo)
 *   7. Infinity scroll per grid paginate (collection + search)
 *
 * Estratto dai blocchi <script> di main-collection-product-grid.liquid
 * per riutilizzo sulla search results page. Tutti i blocchi sono IIFE
 * idempotenti con guard interno → safe da caricare anche se la pagina
 * non ha drawer (no-op se gli elementi non esistono).
 * ============================================================================ */

  (function () {
    if (window.__czHeaderHSync) return;
    window.__czHeaderHSync = true;

    var init = function () {
      var header = document.querySelector('.section-header');
      if (!header) return;

      // ===== 1. Sync --cz-header-current-h =====
      var lastH = 0;
      var updateH = function () {
        var h = header.offsetHeight;
        if (h > 0 && h !== lastH) {
          lastH = h;
          document.documentElement.style.setProperty('--cz-header-current-h', h + 'px');
        }
      };

      updateH();

      if (window.ResizeObserver) {
        new ResizeObserver(updateH).observe(header);
      } else {
        window.addEventListener('resize', updateH);
      }

      header.addEventListener('transitionend', updateH);

      // ===== 2. rAF-driven sticky tracking =====
      // Sincronizza pixel-perfect mini-bar (configuratore Pandora) e toolbar
      // con header.bottom durante le transizioni dell'header globale.
      // Senza questo, transition CSS top sui layer sticky sub-jaceti userebbe
      // un valore stale di --cz-header-current-h (settato solo a transitionend)
      // → gap bianchi visibili durante l'animazione header.
      var rafId = null;
      // Granular transition string per disable solo `top` su mini-bar
      // (conserva transform/opacity che governano il slide-in/out).
      var MINI_BAR_NO_TOP_TRANS =
        'transform 320ms cubic-bezier(.22, 1, .36, 1), opacity 220ms ease, top 0ms';

      var tick = function () {
        var headerBottom = header.getBoundingClientRect().bottom;
        var top = Math.max(0, headerBottom);
        var miniBar = document.querySelector('[data-mini-bar]');
        var toolbar = document.querySelector('.facets-wrapper--with-title');
        var miniH = 0;
        if (miniBar) {
          miniBar.style.top = top + 'px';
          if (miniBar.classList.contains('is-visible')) {
            // Leggi --cz-mini-bar-h (single source of truth scritto da
            // setupMiniBarVisibility() con ceil → stabile). Fallback a
            // offsetHeight per altri usi non-Pandora del data-mini-bar.
            miniH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cz-mini-bar-h')) || Math.round(miniBar.offsetHeight);
          }
        }
        if (toolbar) {
          toolbar.style.top = (top + miniH) + 'px';
        }
        rafId = requestAnimationFrame(tick);
      };

      var startTrack = function () {
        if (rafId) return;
        var miniBar = document.querySelector('[data-mini-bar]');
        var toolbar = document.querySelector('.facets-wrapper--with-title');
        if (!miniBar && !toolbar) return;
        if (miniBar) miniBar.style.transition = MINI_BAR_NO_TOP_TRANS;
        if (toolbar) toolbar.style.transition = 'none';
        rafId = requestAnimationFrame(tick);
      };

      var stopTrack = function () {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        var miniBar = document.querySelector('[data-mini-bar]');
        var toolbar = document.querySelector('.facets-wrapper--with-title');
        // Pulisci inline top + transition: la regola CSS state-based
        // (con/senza .shopify-section-header-hidden) ridà il valore
        // corretto, identico all'ultimo frame del tick — niente jump.
        if (miniBar) {
          miniBar.style.top = '';
          miniBar.style.transition = '';
        }
        if (toolbar) {
          toolbar.style.top = '';
          toolbar.style.transition = '';
        }
      };

      // Desktop (>=990) anima `transform`, mobile usa `top` (vedi
      // base.css:2330 .section-header.animate { transition: top 0.15s }).
      // Coprire entrambi così il rAF parte/ferma su qualunque dei due.
      var isHeaderProp = function (name) {
        return name === 'transform' || name === 'top';
      };
      header.addEventListener('transitionrun', function (e) {
        if (isHeaderProp(e.propertyName)) startTrack();
      });
      header.addEventListener('transitionend', function (e) {
        if (isHeaderProp(e.propertyName)) stopTrack();
      });
      header.addEventListener('transitioncancel', function (e) {
        if (isHeaderProp(e.propertyName)) stopTrack();
      });

      // Mobile fallback: il scroll-down hide su mobile cambia top
      // istantaneamente (no .animate class su hide → no transition →
      // niente transitionrun fires). MutationObserver cattura le class
      // change e fa partire un rAF burst così la toolbar comunque si
      // sincronizza con la nuova posizione header. transitionend di
      // un'eventuale transition concomitante chiuderà rAF prima del
      // timer di fallback. =====
      var bumpTimer = null;
      var bumpTrack = function () {
        startTrack();
        if (bumpTimer) clearTimeout(bumpTimer);
        bumpTimer = setTimeout(stopTrack, 600);
      };

      new MutationObserver(function () {
        updateH();
        bumpTrack();
      }).observe(header, {
        attributes: true,
        attributeFilter: ['class']
      });

      // ===== 3. Toggle .cz-stuck quando la toolbar è effettivamente
      //         pinnata. Discrimina "header sticky-compact" da
      //         "toolbar sticky-pinned": il primo accade ~al primo
      //         scroll (>100px), il secondo solo quando la posizione
      //         naturale della toolbar è scrollata oltre la sticky pin
      //         position (= var(--cz-header-current-h) o 0 in stato
      //         hidden). Misuriamo rect.top: quando ≤ soglia di pin,
      //         sticky è ingaggiata. =====
      var rafCheckScheduled = false;
      var checkStuck = function () {
        rafCheckScheduled = false;
        var toolbar = document.querySelector('.facets-wrapper--with-title');
        if (!toolbar) return;
        var rect = toolbar.getBoundingClientRect();
        var pinAt = lastH > 0 ? lastH : 60;
        // Se sopra la toolbar c'è un altro layer sticky (es. mini-bar del
        // configuratore Pandora che espone la sua altezza in --cz-mini-bar-h),
        // includilo nella soglia di pin: altrimenti `.cz-stuck` non si attiva
        // mai perché rect.top resta > pinAt anche quando la toolbar è pinnata.
        var miniH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cz-mini-bar-h')) || 0;
        pinAt += miniH;
        // +1 tolleranza per evitare flicker su sub-pixel rounding.
        toolbar.classList.toggle('cz-stuck', rect.top <= pinAt + 1);
      };
      var scheduleStuckCheck = function () {
        if (rafCheckScheduled) return;
        rafCheckScheduled = true;
        requestAnimationFrame(checkStuck);
      };

      window.addEventListener('scroll', scheduleStuckCheck, { passive: true });
      window.addEventListener('resize', scheduleStuckCheck);
      // Stato iniziale (primo check post-init).
      scheduleStuckCheck();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  // Filter values "Show more" toggle — collassa lista oltre 3 righe.
  (function () {
    function applyShowMore() {
      document.querySelectorAll('.mobile-facets__details').forEach(function (details) {
        var list = details.querySelector('.mobile-facets__list');
        var btn = details.querySelector('.mobile-facets__show-more');
        if (!list || !btn) return;

        // Se l'utente ha già espanso, non toccare nulla (preserva user choice)
        if (btn.getAttribute('aria-expanded') === 'true') return;

        // Se la lista non è visibile (submenu chiuso), skip misurazione.
        // Il submenu ora non è più display:none (animato via max-height) →
        // offsetParent non è null da chiuso: aggiungo !details.open per
        // saltare comunque gli accordion chiusi nella misura bulk.
        if (list.offsetParent === null || !details.open) return;

        // Misura overflow per decidere se mostrare il button
        // List è già collapsed via CSS (max-height 14.6rem); confronta scrollHeight
        // con clientHeight per capire se ci sono più di 3 righe.
        var hasOverflow = list.scrollHeight > list.clientHeight + 2;
        if (hasOverflow) {
          btn.classList.add('is-visible');
        } else {
          btn.classList.remove('is-visible');
          // Niente overflow: rimuovi limite max-height per mostrare tutto
          list.classList.add('is-expanded');
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mobile-facets__show-more');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var details = btn.closest('.mobile-facets__details');
      if (!details) return;
      var list = details.querySelector('.mobile-facets__list');
      var moreText = btn.querySelector('.mobile-facets__show-more-text-more');
      var lessText = btn.querySelector('.mobile-facets__show-more-text-less');
      var expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        list.classList.remove('is-expanded');
        btn.setAttribute('aria-expanded', 'false');
        if (moreText) moreText.hidden = false;
        if (lessText) lessText.hidden = true;

        // Scroll: porta il filtro corrente all'inizio del panel DOPO il reflow.
        // Usiamo setTimeout 80ms per garantire che il browser abbia ricalcolato
        // layout e clamped scrollTop dopo il collapse della lista.
        setTimeout(function () {
          var panel = details.closest('.mobile-facets__inner');
          if (!panel) return;
          // offsetTop del details rispetto al panel (panel è position: relative)
          var targetTop = details.offsetTop - 24;
          if (targetTop < 0) targetTop = 0;
          panel.scrollTop = targetTop;
        }, 80);
      } else {
        list.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
        if (moreText) moreText.hidden = true;
        if (lessText) lessText.hidden = false;
      }
    });

    // Init quando il drawer si apre + ad ogni rerender filtri (mutation observer leggero).
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyShowMore);
    } else {
      applyShowMore();
    }

    // Re-apply quando filtri si re-renderano via AJAX (osserva mutazioni nel main).
    var mainEl = document.querySelector('.mobile-facets__main');
    if (mainEl && 'MutationObserver' in window) {
      var obs = new MutationObserver(function () { applyShowMore(); });
      obs.observe(mainEl, { childList: true, subtree: true });
    }

    // Re-apply quando un filtro details si apre (per ricalcolare overflow).
    document.addEventListener('toggle', function (e) {
      if (e.target.matches && e.target.matches('.mobile-facets__details')) {
        setTimeout(applyShowMore, 50);
      }
    }, true);
  })();
  // Accordion filtri — animazione ad ALTEZZA REALE. Il submenu via CSS ha
  // max-height:0 chiuso (transition 850ms). Qui in JS settiamo max-height
  // = scrollHeight ESATTO ad ogni toggle → la durata PERCEPITA == 850ms
  // ogni volta (col tetto fisso 200rem la parte visibile finiva in ~50ms).
  //
  // CRUCIALE: il CSS ha max-height con !important (base 0, [open] 200rem).
  // Un inline SENZA !important NON batte un !important del foglio di stile
  // → va usato setProperty(..., 'important') (inline-important vince anche
  // sull'author-important). Senza questo il JS era ignorato e restava la
  // vecchia animazione CSS 0↔200rem (overshoot → percepita istantanea,
  // "solo la prima volta"). Progressive enhancement: senza JS resta il
  // fallback CSS [open] max-height:200rem (contenuto comunque visibile).
  // Chiusura SIMMETRICA all'apertura: al `toggle` di chiusura il browser
  // ha già nascosto il contenuto → scrollHeight=0 → chiusura istantanea.
  // Quindi catturiamo l'altezza reale in `beforetoggle` (scatta PRIMA del
  // cambio stato, contenuto ancora presente) e fissiamo lì il valore di
  // partenza px; il `toggle` poi anima solo verso 0 → stessi 850ms
  // dell'apertura.
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var imp = function (el, prop, v) { el.style.setProperty(prop, v, 'important'); };
    var clearEnd = function (el) {
      if (el._czEnd) {
        el.removeEventListener('transitionend', el._czEnd);
        el._czEnd = null;
      }
    };
    var sub = function (d) {
      return d && d.matches && d.matches('.mobile-facets__details')
        ? d.querySelector(':scope > .mobile-facets__submenu')
        : null;
    };

    // Fissa il punto di partenza (altezza reale + opacity:1) PRIMA che il
    // <details> si chiuda, finché il contenuto è ancora renderizzato.
    // Doppia cattura per affidabilità: `beforetoggle` (Chrome 130+) E
    // `click` sul summary in fase capture (universale, scatta prima del
    // toggle nativo). Idempotente.
    var captureClose = function (d) {
      var el = sub(d);
      if (!el) return;
      clearEnd(el);
      if (reduce.matches) { imp(el, 'max-height', '0px'); return; }
      imp(el, 'max-height', el.scrollHeight + 'px');
      imp(el, 'opacity', '1');
      void el.offsetHeight; // commit del valore di partenza
    };

    document.addEventListener('beforetoggle', function (e) {
      if (e.newState === 'closed') captureClose(e.target);
    }, true);

    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('summary');
      if (!s) return;
      var d = s.parentElement;
      if (d && d.matches && d.matches('.mobile-facets__details') && d.open) {
        captureClose(d); // d.open al click ⇒ si sta CHIUDENDO
      }
    }, true);

    document.addEventListener('toggle', function (e) {
      var d = e.target;
      var el = sub(d);
      if (!el) return;

      clearEnd(el);

      // Reduced motion: nessuna animazione (CSS azzera già la transition).
      if (reduce.matches) {
        imp(el, 'max-height', d.open ? 'none' : '0px');
        imp(el, 'opacity', d.open ? '1' : '0');
        return;
      }

      if (d.open) {
        // Apertura: 0 → altezza reale. opacity inline-important così il
        // quirk Dawn (.menu-opening ri-aggiunta) non la sovrascrive.
        imp(el, 'opacity', '1');
        imp(el, 'max-height', '0px');
        void el.offsetHeight; // reflow: fissa lo stato di partenza
        imp(el, 'max-height', el.scrollHeight + 'px');
        el._czEnd = function (ev) {
          if (ev.propertyName !== 'max-height') return;
          el.removeEventListener('transitionend', el._czEnd);
          el._czEnd = null;
          // A fine apertura: max-height:none così "mostra di più" / AJAX
          // non vengono clippati.
          if (d.open) imp(el, 'max-height', 'none');
        };
        el.addEventListener('transitionend', el._czEnd);
      } else {
        // Chiusura: partenza (altezza px + opacity 1) già fissata da
        // captureClose → anima verso 0 (stessi 850ms / 600ms dell'apertura).
        imp(el, 'max-height', '0px');
        imp(el, 'opacity', '0');
      }
    }, true);
  })();
  // L'altezza del drawer NON si misura piu' da JavaScript.
  //
  // Qui c'era un blocco che leggeva window.visualViewport.height e la imponeva
  // al pannello, sia via --cz-drawer-h sia con style.height inline. Era una
  // fotografia, e andava scattata in un istante: aprendo il pannello dopo aver
  // scorso, iOS riespande le proprie barre in ~300ms mentre la misura avveniva
  // dopo due fotogrammi. Il pannello nasceva piu' alto dello spazio visibile e
  // il suo piede finiva sotto le barre.
  //
  // Ora decide il CSS con 100dvh (cz-facets-drawer.css), che il browser tiene
  // aggiornata da solo mentre le barre si aprono e si chiudono: non ha un
  // istante in cui viene scattata, quindi non puo' essere scattata
  // nell'istante sbagliato. 100vh resta come ripiego per i browser antichi.
  // Chiusura drawer filtri alla stessa velocità del drawer prodotto
  // desktop (1300ms). Dawn (global.js MenuDrawer.closeAnimation) rimuove
  // l'attributo [open] dopo 400ms fissi → collassa il <details> e tronca
  // qualsiasi transition di chiusura più lunga. Estendiamo quella finestra
  // a 1300ms SOLO per il drawer filtri mobile.
  //
  // Patch sul PROTOTYPE (non sull'istanza) perché Dawn rimpiazza l'intero
  // <menu-drawer> ad ogni AJAX dei filtri: un override d'istanza si
  // perderebbe. Guardia interna su .mobile-facets__disclosure così
  // header-drawer (eredita lo stesso prototype), submenu dei gruppi
  // filtro e ogni altro menu-drawer restano sul comportamento originale.
  (function () {
    // Chiusura drawer filtri = 600ms (apertura resta 1300ms). Tenere
    // [open] solo ~650ms (= close 600ms + buffer) libera subito lo stato
    // del drawer sulle collezioni → StickyHeader/toolbar-sync non disturbati
    // (header fluido). Le transition CSS close sono 600ms (asimmetriche
    // vs open 1300ms via selettore .menu-opening).
    var CLOSE_MS = 650;
    customElements.whenDefined('menu-drawer').then(function () {
      var Ctor = customElements.get('menu-drawer');
      if (!Ctor || Ctor.prototype.__czClosePatched) return;
      var original = Ctor.prototype.closeAnimation;
      Ctor.prototype.__czClosePatched = true;
      Ctor.prototype.closeAnimation = function (detailsElement) {
        var isFacetsDrawer =
          detailsElement &&
          detailsElement === this.mainDetailsToggle &&
          detailsElement.classList.contains('mobile-facets__disclosure');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!isFacetsDrawer || reduceMotion) {
          return original.call(this, detailsElement);
        }
        var start;
        function step(time) {
          if (start === undefined) start = time;
          if (time - start < CLOSE_MS) {
            window.requestAnimationFrame(step);
          } else if (!detailsElement.classList.contains('menu-opening')) {
            // Ancora in chiusura (non riaperto nel frattempo) → collassa.
            detailsElement.removeAttribute('open');
          }
        }
        window.requestAnimationFrame(step);
      };
    });
  })();
  // Custom dropdown ORDINA PER — sostituisce dropdown nativo browser
  // con panel Tiffany-style. Click su box → toggle. Click su opzione →
  // setta value sul <select> nascosto + dispatch change (Dawn fa AJAX).
  (function () {
    document.addEventListener('click', function (e) {
      var option = e.target.closest('.cz-sort-dropdown__option');
      if (option) {
        e.preventDefault();
        e.stopPropagation();
        var dropdown = option.closest('.cz-sort-dropdown');
        if (!dropdown) return;
        var select = dropdown.querySelector('select');
        if (select) {
          select.value = option.dataset.sortValue;
          // Dawn (facets.js:11) ascolta `input` sul form per debounced AJAX.
          // `change` per coerenza con native <select>. Bubbles=true così
          // arriva al <form> parent.
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        dropdown.querySelectorAll('.cz-sort-dropdown__option').forEach(function (o) {
          var isActive = o === option;
          o.classList.toggle('is-active', isActive);
          o.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        dropdown.classList.remove('is-open');
        return;
      }

      var dropdownTrigger = e.target.closest('.cz-sort-dropdown');
      if (dropdownTrigger) {
        e.preventDefault();
        // Chiudi altri eventuali aperti
        document.querySelectorAll('.cz-sort-dropdown.is-open').forEach(function (d) {
          if (d !== dropdownTrigger) d.classList.remove('is-open');
        });
        dropdownTrigger.classList.toggle('is-open');
        return;
      }

      // Click outside → chiudi tutti
      document.querySelectorAll('.cz-sort-dropdown.is-open').forEach(function (d) {
        d.classList.remove('is-open');
      });
    });

    // ESC chiude il dropdown
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.cz-sort-dropdown.is-open').forEach(function (d) {
          d.classList.remove('is-open');
        });
      }
    });
  })();
  // Infinity scroll per le pagine collection: carica la pagina successiva
  // quando l'utente è entro 1500px dal fondo del grid → caricamento
  // anticipato di ~2-3 schermate, niente attesa al bottom. Pagination DOM
  // resta come fallback no-JS ma viene nascosta via CSS (data-infinity-
  // scroll="active") quando lo script si attiva.
  (function () {
    if (!document.getElementById('product-grid')) return;

    // NIENTE RIFERIMENTI CONSERVATI. La versione precedente catturava grid e
    // nextUrl una volta sola all'avvio. Ma quando si applica un filtro,
    // facets.js SOSTITUISCE la griglia nel DOM: il riferimento conservato
    // puntava a un nodo staccato, il cui getBoundingClientRect() vale zero.
    // "Distanza dal fondo zero" faceva scattare loadMore in catena: pagine
    // NON filtrate scaricate una dopo l'altra, prodotti appesi al nodo
    // staccato (invisibili), e la paginazione visibile che scalava da sola
    // fino all'ultima pagina. Visto dal vivo su /collections/anelli con il
    // filtro "a forma di cuore": 26 → 28 → 31 senza toccare niente.
    // Ora griglia e collegamento "successiva" si rileggono dal DOM vivo a
    // ogni ciclo: dopo un filtro si prosegue con le pagine FILTRATE.

    function grid() {
      var g = document.getElementById('product-grid');
      return g && g.isConnected ? g : null;
    }

    function findNextUrl() {
      // Nel pagination snippet del theme il "next" link è marcato come
      // .pagination__item--prev (naming Dawn legacy invertito ma fedele
      // all'output di `paginate.next`).
      var nextLink = document.querySelector('.pagination-wrapper .pagination__item--prev');
      return nextLink ? nextLink.getAttribute('href') : null;
    }

    var collection = document.getElementById('product-grid').closest('.collection');
    if (!collection) return;
    if (!findNextUrl()) return;

    collection.setAttribute('data-infinity-scroll', 'active');
    var loading = false;
    var TRIGGER_DISTANCE = 1500;

    function loadMore() {
      var g = grid();
      var nextUrl = findNextUrl();
      if (loading || !g || !nextUrl) return;
      loading = true;
      collection.setAttribute('data-infinity-loading', 'true');

      fetch(nextUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var newProducts = newGrid ? newGrid.querySelectorAll(':scope > .grid__item') : [];

          // La griglia potrebbe essere stata sostituita DURANTE il fetch
          // (l'utente ha toccato un filtro): si riappende a quella viva.
          var vivo = grid();
          if (vivo) {
            newProducts.forEach(function (li) {
              li.removeAttribute('data-cascade');
              li.style.removeProperty('--animation-order');
              vivo.appendChild(li);
            });
          }

          var oldPagination = document.querySelector('.pagination-wrapper');
          var newPagination = doc.querySelector('.pagination-wrapper');
          if (oldPagination && newPagination) {
            oldPagination.replaceWith(newPagination);
          } else if (oldPagination && !newPagination) {
            oldPagination.remove();
          }

          loading = false;
          collection.removeAttribute('data-infinity-loading');

          // Prosegue solo se questo giro ha davvero aggiunto qualcosa:
          // una pagina vuota che rilancia se stessa e' il cappio di prima.
          if (newProducts.length > 0 && findNextUrl()) checkAndLoad();
        })
        .catch(function (err) {
          console.warn('[cz-infinity]', err);
          loading = false;
          collection.removeAttribute('data-infinity-loading');
        });
    }

    function checkAndLoad() {
      var g = grid();
      if (loading || !g || !findNextUrl()) return;
      var gridRect = g.getBoundingClientRect();
      var distanceToBottom = gridRect.bottom - window.innerHeight;
      if (distanceToBottom <= TRIGGER_DISTANCE) {
        loadMore();
      }
    }

    var rafId = null;
    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        checkAndLoad();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Check iniziale: se la prima pagina è già vicina al fondo viewport
    // (es. mobile con poche righe, filtri attivi) carica subito senza
    // aspettare scroll.
    setTimeout(checkAndLoad, 100);
  })();
